import { DesafioHackathon } from './../../../models/hackathon.model';
import { EntregaEquipe } from './../../../models/equipe.model';
import { HelpersService } from 'src/app/services/helpers.service';
import { DatabaseService } from './../../../services/database.service';
import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { Equipe } from '../../../models/equipe.model';
import { Hackathon } from 'src/app/models/hackathon.model';

@Component({
  selector: 'app-escolha-desafio',
  templateUrl: './escolha-desafio.component.html',
  styleUrls: ['./escolha-desafio.component.css']
})
export class EscolhaDesafioComponent implements OnInit {

  private hackathonDesafios: DesafioHackathon[] = this.helper.hackathonDesafios;
  private equipeId: string = this.helper.getEquipeId();
  step = -1;
  desafios = [];
  showSpinner = true;
  private userId: string;
  empatou = false;
  equipe: Equipe;
  votos: boolean[] = [];
  votosCount: number[] = [];
  indexMaisVotado: number;
  indexVotoMembro: number;

  constructor(private auth: AuthService,
              private database: DatabaseService,
              private helper: HelpersService) { }

  ngOnInit() {
    this.desafios = this.helper.hackathonDesafios;

    // zera os votos
    this.desafios.forEach(e => {
      this.votos.push(false);
      this.votosCount.push(0);
    });

    this.database.getEquipe(this.equipeId)
    .then(rawData => rawData.subscribe((data: Equipe[]) => {
      this.equipe = data.find(e => e.equipeId === this.equipeId);

      this.auth.getUser.then(user => {
        this.userId = user.user.uid;
        this.votoIndexMembro();
        this.showSpinner = false;
      });
    }));
  }

  votoIndexMembro() {
    this.equipe.votosDesafio.forEach((membro, i) => {
      if (membro.uid === this.userId) {
        this.indexVotoMembro = i;
        if (!this.helper.isNullOrUndefined(this.votos)) {
          this.votos[membro.desafio] = true;
        }
      }
    });
    this.atualizaContagem();
  }

  insereVoto(i) {
    if (!this.helper.isNullOrUndefined(this.indexVotoMembro)) {
      //Atualiza voto
      this.equipe.votosDesafio[this.indexVotoMembro].desafio = i;
    } else {
      //Novo voto
      let votoDesafio = {
        uid: this.userId,
        desafio: i
      };
      this.equipe.votosDesafio.push(votoDesafio);
    }
    this.votoIndexMembro();
    this.atualizaVotos(i);
  }

  atualizaVotos(i) {
    //Atualiza icon de votação
    this.votos.forEach((e, index) => {
      this.votos[index] = (index === i) ? true : false;
    });
    this.atualizaContagem();
  }

  atualizaContagem() {
    //Zera a contagem
    this.votosCount.forEach((e, i) => {
      this.votosCount[i] = 0;
    });

    //Atualiza a contagem
    this.equipe.votosDesafio.forEach((e, i) => {
      this.votosCount[e.desafio]++;
    });

    this.empate(this.votosCount);
  }

  // Abre descricao do desafio
  setStep(index: number) {
    this.step = (index === this.step) ? -1 : index;
  }

  empate(votos: number[]) {
    let empate = 0;
    let maiorVoto = 0;
    this.indexMaisVotado = 0;

    // pega o maior voto
    votos.forEach(v => {
      if (v > maiorVoto) {
        maiorVoto = v;
      }
    });

    // compara se tem um voto igual a ele
    votos.forEach((v, i) => {
      if (maiorVoto === v) {
        this.indexMaisVotado = i;
        empate++;
      }
    });
    // console.log(empate + ' | ' + maiorVoto + ' | ' + this.empatou);

    if (empate > 1) {
      this.empatou = true;
    } else {
      this.empatou = false;
    }
  }

  atribuiDesafio() {
    this.equipe.desafioEscolhido.titulo = this.hackathonDesafios[this.indexMaisVotado].titulo;
    this.equipe.desafioEscolhido.descricao = this.hackathonDesafios[this.indexMaisVotado].descricao;
    this.criaEntrega();
    this.helper.routeToResumoEquipe(this.equipeId);
  }

  criaEntrega() {
    // Cria registro de entrega para a equipe
    let entregaDesafio: EntregaEquipe = {
      avaliativa: false,
      atrasado: false,
      entregue: true,
      dataHoraEntrega: new Date().toUTCString(),
      conteudo: this.equipe.desafioEscolhido.titulo,
      titulo: 'Escolha do desafio'
    };

    this.equipe.entregas.push(entregaDesafio);
    this.database.updateEquipe(this.equipe);
  }

}
